import { IconButton, Card, CardContent, Typography } from "@mui/material";

import FastRewindIcon from "@mui/icons-material/FastRewind";
import BadgeIcon from "@mui/icons-material/Badge";

import { DossierCapability } from "types/DossierCapability";

import HoverPopover from "material-ui-popup-state/HoverPopover";
import {
    usePopupState,
    bindHover,
    bindPopover,
} from "material-ui-popup-state/hooks";

import { DossierCapabilityName } from "types/DossierCapabilityName";

export interface DossierCapabilitiyIconProps {
    dossierCapability: DossierCapability;
}

export function DossierCapabilitiyIcon(props: DossierCapabilitiyIconProps) {
    const popupState = usePopupState({
        variant: "popover",
        popupId: "siteInformationCard",
    });

    return (
        <>
            <IconButton
                {...bindHover(popupState)}
                disableRipple
                sx={{ cursor: "help" }}
            >
                {props.dossierCapability.name ===
                    DossierCapabilityName.ReversePlaybackUsingReversedVideos && (
                    <FastRewindIcon />
                )}
                {props.dossierCapability.name ===
                    DossierCapabilityName.ReIdentification && <BadgeIcon />}
            </IconButton>
            <HoverPopover
                {...bindPopover(popupState)}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                <Card sx={{ minWidth: 275 }}>
                    <CardContent>
                        <Typography variant="h5">
                            {props.dossierCapability.displayName}
                        </Typography>
                        <Typography variant="body2">
                            {props.dossierCapability.description}
                        </Typography>
                    </CardContent>
                </Card>
            </HoverPopover>
        </>
    );
}
